module.exports = __webpack_public_path__ + "static/lframe-debt-con-6d20a027059a9ca513dca50086a7d30b.png";